import React from 'react';
import { Lightbox } from '../../../../modal_image';

const Gallery = ({
  onKeyDown,
  onClose,
  onPrev,
  onNext,
  preview,
  name,
  loading,
}) => {
  return (
    <div ref={makeFocus} onKeyDown={onKeyDown} tabIndex={0}>
      <Lightbox
        medium={preview}
        large={preview}
        onClose={onClose}
        alt={name}
        onPrev={onPrev}
        onNext={onNext}
        loading={loading}
      />
    </div>
  );
};

export default Gallery;

function makeFocus(node) {
  if (node) {
    node.focus();
  }
}
